﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_infoPage from './tpl/infoPage.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';
import View_Pagination from '../../../lib/views/pagination/pagination';
//import View_infoPageList from './infoPageList';
import View_infoPageListItem from './infoPageListItem';
import * as Entities_Memory_Position from '../../entities/memoryPosition';
import View_DigitalClock from '../../../portal/info/module/digitalClock';

export default Marionette.LayoutView.extend({
    getTemplate: function () {
        return tpl_infoPage({ model: this.model.toJSON() });
    },
    initialize: function () {
        var self = this;
        this.app = this.options.app;

        this.counter = 0;

        this.informationCollection = new Entities_Empty.Collection();
        this.localSetting = new Entities_Empty.Model();
        this.initCollection();
        this.buildCollection();

        if (this.model.attributes.LogoUrl == undefined) {
            this.model.attributes.LogoUrl = '/images/luxafor/luxaforboard_trans.png';
        }

        this.module002Model = this.moduleCollection.where({ ModuleType: 20 })[0];

        var userChannel = Backbone.Radio.channel('app');
        userChannel.on('SignalR:ChangeModel', function (model) {
            var tmpModel = self.collection.where({ CallerId: model.attributes.CallerId })[0];

            if (tmpModel != undefined) {
                tmpModel.set({
                    Color: model.attributes.Color,
                    ActiveTab: model.attributes.ActiveTab,
                    Text: model.attributes.Text,
                    Timestamp: model.attributes.Timestamp,
                    Timeleft: model.attributes.Timeleft,
                    DepartmentResetText: model.attributes.DepartmentResetText
                });
            }
        });

        this.setHasChanged(false);
    },
    setHasChanged: function (enable) {
        this.hasChanged = enable;
    },
    getHasChanged: function () {
        return this.hasChanged;
    },
    saveHasChanged: function (callback) {
        callback();
    },
    cancelHasChanged: function () {
    },
    modelHasChanged: function () {
    },
    regions: {
        module001: "#module001",
        //infoPageList: "#infoPageList"
        infoPageListListItem01: "#infoPageListListItem01",
        infoPageListListItem02: "#infoPageListListItem02",
        infoPageListListItem03: "#infoPageListListItem03",
        infoPageListListItem04: "#infoPageListListItem04",
        infoPageListListItem05: "#infoPageListListItem05",
        infoPageListListItem06: "#infoPageListListItem06",
        infoPageListListItem07: "#infoPageListListItem07",
        infoPageListListItem08: "#infoPageListListItem08",
        infoPageListListItem09: "#infoPageListListItem09",
        infoPageListListItem10: "#infoPageListListItem10",
        infoPageListListItem11: "#infoPageListListItem11",
        infoPageListListItem12: "#infoPageListListItem12",
        infoPageListListItem13: "#infoPageListListItem13",
        infoPageListListItem14: "#infoPageListListItem14",
        infoPageListListItem15: "#infoPageListListItem15",
        infoPageListListItem16: "#infoPageListListItem16",
        infoPageListListItem17: "#infoPageListListItem17",
        infoPageListListItem18: "#infoPageListListItem18",
        infoPageListListItem19: "#infoPageListListItem19",
        infoPageListListItem20: "#infoPageListListItem20"
    },
    ui: {
        'infoPage_department': '#infoPage_department'
    },
    initModule(model) {
        var ret;

        ret = new View_DigitalClock({ app: this.app, model: model, templateModel: this.model, customEvent: this.options.customEvent });

        return ret;
    },
    onRender: function () {
        var self = this;
        //this.onRenderComplete(); 

        //if (this.model.attributes.infoPage_ImageUrl == null) {
        //    this.ui.infoPage_ImageUrl.css('display', 'none');
        //    this.ui.infoPage_Name.show();
        //}
        //else {
        //    this.ui.infoPage_Name.css('display', 'none');
        //    this.ui.infoPage_ImageUrl.show();
        //}


        this.ui.module_infoPage_Name_margin.css('margin-top', this.module002Model.attributes.Data.ModuleMargin_Top + 'px');
        this.ui.module_infoPage_Name_margin.css('margin-bottom', this.module002Model.attributes.Data.ModuleMargin_Bottom + 'px');
        this.ui.module_infoPage_Name_margin.css('margin-left', this.module002Model.attributes.Data.ModuleMargin_Left + 'px');
        this.ui.module_infoPage_Name_margin.css('margin-right', this.module002Model.attributes.Data.ModuleMargin_Right + 'px');

        this.ui.infoPage_Name.css('margin-top', this.module002Model.attributes.Data.Margin1_Top + 'px');
        this.ui.infoPage_Name.css('margin-bottom', this.module002Model.attributes.Data.Margin1_Bottom + 'px');
        this.ui.infoPage_Name.css('margin-left', this.module002Model.attributes.Data.Margin1_Left + 'px');
        this.ui.infoPage_Name.css('margin-right', this.module002Model.attributes.Data.Margin1_Right + 'px');

        var font1_textAlign = this.app.entities.collections.TextAlign.where({
            Value: this.module002Model.attributes.Data.Font1_TextAlign
        });

        font1_textAlign[0].attributes.CssStyle.forEach(function (entry) {
            self.ui.infoPage_Name.css(entry.Css, entry.Value);
        });

        this.ui.infoPage_Name.css('font-family', this.module002Model.attributes.Data.Font1);
        this.ui.infoPage_Name.css('font-size', this.module002Model.attributes.Data.Font1_Size);
        this.ui.infoPage_Name.css('color', this.module002Model.attributes.Data.Font1_Color);

        var font1_style = this.app.entities.collections.FontStyle.where({
            Value: this.module002Model.attributes.Data.Font1_Style
        });

        font1_style[0].attributes.CssStyle.forEach(function (entry) {
            self.ui.infoPage_Name.css(entry.Css, entry.Value);
        });

        this.afterRender();
    },
    afterRender: function () {
        this.module001Model = this.moduleCollection.where({ ModuleType: 4 })[0];

        if (this.module001Model != undefined && this.module001Model.attributes.Data.EnableModule == 1) {
            this.module001.destroy();
            this.module001.show(this.initModule(this.module001Model));
        }

        this.setupBackground();
    },
    initCollection: function () {
        this.options.curScreen = 0;
        this.options.totalScreen = Math.ceil(this.app.entities.collections.customDepartmentUser.length / 20) - 1;

        for (var i = 0; i < 20; i++) {
            var tmpModel = new this.collection.model();
            tmpModel.attributes.id = i;
            tmpModel.attributes.CallerId = i;
            tmpModel.attributes.Name = '';
            tmpModel.attributes.FirstName = '';
            tmpModel.attributes.ActiveTab = '';
            tmpModel.attributes.Color = '#ff0000';
            tmpModel.attributes.ImageUrl = '';
            tmpModel.attributes.AuthUserId = '';
            tmpModel.attributes.WebhookUrl = '';
            tmpModel.attributes.Text = '';

            //var now = new Date();

            /*var utcDateTime = now.getUTCFullYear().toString() + '-' +
                (now.getUTCMonth() + 1) + '-' +
                now.getUTCDate().toString() + ' ' +
                now.getUTCHours() + ':' +
                now.getUTCMinutes() + ':' +
                now.getUTCSeconds();
                */

            tmpModel.attributes.Timestamp = '';//utcDateTime;
            tmpModel.attributes.TmpTimeleft = '00:00';

            this.collection.add(tmpModel);
        }

        var data = JSON.parse(this.model.attributes.Data)[0];
        this.moduleCollection = new Entities_Memory_Position.Collection(data.Collection);
    },
    GetText: function (color, ActiveTab, DepartmentResetText) {
        var ret = '';

        if (DepartmentResetText != '') return DepartmentResetText;

        if (ActiveTab == "Microsoft Teams") {
            if (color == this.model.attributes.MSTeams_Color_Online) ret = this.model.attributes.MSTeams_Text_Online;
            else if (color == this.model.attributes.MSTeams_Color_Busy) ret = this.model.attributes.MSTeams_Text_Busy;
            else if (color == this.model.attributes.MSTeams_Color_DoNotDisturb) ret = this.model.attributes.MSTeams_Text_DoNotDisturb;
            else if (color == this.model.attributes.MSTeams_Color_BeRightBack) ret = this.model.attributes.MSTeams_Text_BeRightBack;
            else if (color == this.model.attributes.MSTeams_Color_ShowAsNotPresent) ret = this.model.attributes.MSTeams_Text_ShowAsNotPresent;
            else if (color == this.model.attributes.MSTeams_Color_ShowAsOffline) ret = this.model.attributes.MSTeams_Text_ShowAsOffline;

        } else if (ActiveTab == "Mutebutton") {
            if (color == this.model.attributes.Mutebutton_Color_On) ret = this.model.attributes.Mutebutton_Text_On;
            else if (color == this.model.attributes.Mutebutton_Color_Off) ret = this.model.attributes.Mutebutton_Text_Off;
        } else if (ActiveTab == resources.X200311) {
            if (color == this.model.attributes.Custom_Color_Default) ret = this.model.attributes.Custom_Text_Default;
        } else if (ActiveTab == 'Webhook') {
            if (color == this.model.attributes.Pomodoro_Color_Time) ret = this.model.attributes.Pomodoro_Text_Time;
            else if (color == this.model.attributes.Pomodoro_Color_ShortBreak) ret = this.model.attributes.Pomodoro_Text_ShortBreak;
            else if (color == this.model.attributes.Pomodoro_Color_LongBreak) ret = this.model.attributes.Pomodoro_Text_LongBreak;
        } else {
            if (color == this.model.attributes.Custom_Color_Default) ret = this.model.attributes.Custom_Text_Default;
            else if (color == this.model.attributes.SolidColor_Color_Off) ret = this.model.attributes.SolidColor_Text_Off;
            else if (color == this.model.attributes.SolidColor_Color_Busy) ret = this.model.attributes.SolidColor_Text_Busy;
            else if (color == this.model.attributes.SolidColor_Color_Available) ret = this.model.attributes.SolidColor_Text_Available;
            else if (color == this.model.attributes.SolidColor_Color_Blue) ret = this.model.attributes.SolidColor_Text_Blue;
            else if (color == this.model.attributes.SolidColor_Color_Yellow) ret = this.model.attributes.SolidColor_Text_Yellow;
            else if (color == this.model.attributes.SolidColor_Color_Cyan) ret = this.model.attributes.SolidColor_Text_Cyan;
            else if (color == this.model.attributes.SolidColor_Color_Magenta) ret = this.model.attributes.SolidColor_Text_Magenta;
            else if (color == this.model.attributes.SolidColor_Color_CustomColor) ret = this.model.attributes.SolidColor_Text_CustomColor;
        }

        return ret;
    },
    buildCollection: function () {
        var self = this;
        var incScreen = this.options.curScreen * 20;
        var item = 0;
        var CallerId = 0;
        var Name = '';
        var FirstName = '';
        var Color = '#ff0000';
        var ActiveTab = '';
        var ImageUrl = '';
        var Text = '';

        var now = new Date();

        var utcDateTime = now.getUTCFullYear().toString() + '-' +
            (now.getUTCMonth() + 1) + '-' +
            now.getUTCDate().toString() + ' ' +
            now.getUTCHours() + ':' +
            now.getUTCMinutes() + ':' +
            now.getUTCSeconds();

        var timestamp = '';//utcDateTime;


        for (var i = 0; i < 20; i++) {
            var item = i + incScreen;
            CallerId = i;
            Name = ''
            FirstName = '';
            ActiveTab = '';
            ImageUrl = '';
            Color = '#ff0000';
            Text = '';
            var Timestamp = '';//utcDateTime;
            var Timeleft = '';
            var DepartmentResetText = '';

            var tmpModel = self.collection.models[i];
            if (this.app.entities.collections.customDepartmentUser.models[item] != undefined) {



                CallerId = this.app.entities.collections.customDepartmentUser.models[item].attributes.CallerId;

                if (CallerId == '99') {
                    var a = '';
                }


                Name = this.app.entities.collections.customDepartmentUser.models[item].attributes.Name;
                FirstName = this.app.entities.collections.customDepartmentUser.models[item].attributes.Name;
                Color = this.app.entities.collections.customDepartmentUser.models[item].attributes.Color;
                ActiveTab = this.app.entities.collections.customDepartmentUser.models[item].attributes.ActiveTab;
                ImageUrl = this.app.entities.collections.customDepartmentUser.models[item].attributes.ImageUrl;
                Text = this.GetText(app.entities.collections.customDepartmentUser.models[item].attributes.Color, ActiveTab, app.entities.collections.customDepartmentUser.models[item].attributes.DepartmentResetText);
                //if (Timestamp != undefined) {
                Timestamp = app.entities.collections.customDepartmentUser.models[item].attributes.Timestamp;
                Timeleft = app.entities.collections.customDepartmentUser.models[item].attributes.Timeleft;
                DepartmentResetText = app.entities.collections.customDepartmentUser.models[item].attributes.DepartmentResetText;
                /*} else {
                    Timestamp = '';
                }*/
            }


            tmpModel.set({
                CallerId: CallerId,
                Name: Name,
                FirstName: Name,
                Color: Color,
                ActiveTab: ActiveTab,
                ImageUrl: ImageUrl,
                Text: Text,
                Timestamp: Timestamp,
                Timeleft: Timeleft,
                TmpTimeStamp: '',
                DepartmentResetText: DepartmentResetText
            });
            //this.collection.model[i] = this.app.entities.collections.customDepartmentUser.models[i]

            var elementInt = i + 1;
            var elementStr = '#box0';

            if (elementInt < 10) {
                elementStr += '0';
            }

            elementStr += elementInt;
            if (tmpModel.attributes.Name != '') {
                $(elementStr).show();
            } else {
                $(elementStr).css('display', 'none');
            }



            //if (i == 10 && this.counter > 0) {// $(this.ui.box011).length > 0) {
            //    if (tmpModel.attributes.Name != '' ) {
            //        $(this.ui.box011).show();
            //    } else {
            //        $(this.ui.box011).css('display', 'none');
            //    }
            //}
        }

        this.options.curScreen++;
        if (this.options.curScreen > this.options.totalScreen) this.options.curScreen = 0;
        this.counter++;
    },
    onBeforeShow: function () {
        var self = this;


        var tmpModel = this.collection.models[0];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem01.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box001.css('display', 'none');
        }

        tmpModel = this.collection.models[1];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem02.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box002.css('display', 'none');
        }

        tmpModel = this.collection.models[2];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem03.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box003.css('display', 'none');
        }

        tmpModel = this.collection.models[3];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem04.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box004.css('display', 'none');
        }

        tmpModel = this.collection.models[4];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem05.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box005.css('display', 'none');
        }

        tmpModel = this.collection.models[5];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem06.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box006.css('display', 'none');
        }

        tmpModel = this.collection.models[6];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem07.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box007.css('display', 'none');
        }

        tmpModel = this.collection.models[7];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem08.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box008.css('display', 'none');
        }

        tmpModel = this.collection.models[8];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem09.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box009.css('display', 'none');
        }

        tmpModel = this.collection.models[9];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem10.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box010.css('display', 'none');
        }

        tmpModel = this.collection.models[10];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem11.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box011.css('display', 'none');
        }

        tmpModel = this.collection.models[11];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem12.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box012.css('display', 'none');
        }

        tmpModel = this.collection.models[12];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem13.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box013.css('display', 'none');
        }

        tmpModel = this.collection.models[13];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem14.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box014.css('display', 'none');
        }

        tmpModel = this.collection.models[14];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem15.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box015.css('display', 'none');
        }

        tmpModel = this.collection.models[15];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem16.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box016.css('display', 'none');
        }

        tmpModel = this.collection.models[16];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem17.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box017.css('display', 'none');
        }

        tmpModel = this.collection.models[17];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem18.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box018.css('display', 'none');
        }

        tmpModel = this.collection.models[18];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem19.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box019.css('display', 'none');
        }

        tmpModel = this.collection.models[19];
        if (tmpModel != undefined && tmpModel.attributes.Name != '') {
            this.infoPageListListItem20.show(new View_infoPageListItem({ model: tmpModel, app: this.app, module002Model: this.module002Model }));
        }
        else {
            this.ui.box020.css('display', 'none');
        }



        var timerId = window.setInterval(function () {
            self.buildCollection();

            var timeElapsed = (self.counter * self.model.attributes.TimerView * 1000);
            var refreshPage = 20 * 60 * 1000;

            if (timeElapsed >= refreshPage) {
                window.location.reload();
            }
        }, this.model.attributes.TimerView * 1000);
    },
    ui: {
        'module_infoPage_Name_margin': '#module_infoPage_Name_margin',
        'infoPage_ImageUrl': '#infoPage_ImageUrl',
        'infoPage_Name': '#infoPage_Name',
        'templateBg': '#templateBg',
        'box001': '#box001',
        'box002': '#box002',
        'box003': '#box003',
        'box004': '#box004',
        'box005': '#box005',
        'box006': '#box006',
        'box007': '#box007',
        'box008': '#box008',
        'box009': '#box009',
        'box010': '#box010',
        'box011': '#box011',
        'box012': '#box012',
        'box013': '#box013',
        'box014': '#box014',
        'box015': '#box015',
        'box016': '#box016',
        'box017': '#box017',
        'box018': '#box018',
        'box019': '#box019',
        'box020': '#box020'
    },
    events: {
    },
    onAttach() {
        $('.region101_3').css('background-color', this.module002Model.attributes.Data.Background1_Color);

        if (this.module001Model.attributes.Data.EnableModule == 1) {
            $('.region101_2').css('background-color', this.module001Model.attributes.Data.Background1_Color);
        }

        var ZoomH = Math.floor(this.module002Model.attributes.Data.ZoomH) / 100;
        var ZoomV = Math.floor(this.module002Model.attributes.Data.ZoomV) / 100;

        var scale = ZoomH + ',' + ZoomV;

        $('.zoomContainerH').css({
            '-webkit-transform': 'scale(' + scale + ')',
            '-moz-transform': 'scale(' + scale + ')',
            '-ms-transform': 'scale(' + scale + ')',
            '-o-transform': 'scale(' + scale + ')',
            'transform': 'scale(' + scale + ')'
        });

        var rect = document.getElementsByClassName("zoomContainerH")[0].getBoundingClientRect();

        var width = $(window).width();
        var height = $(window).height();

        var left = (width - rect.width) / 2;
        var top = (height - rect.height) / 2;

        //if (left < 0) left = Math.abs(left);
        //if (top < 0) top = Math.abs(top);

        $('.zoomContainerH').css('margin-left', left + 'px');
        $('.zoomContainerH').css('margin-top', top + 'px');

        //$('.zoomContainerH').css('margin-top', this.module002Model.attributes.Data.ModuleMargin_Top + 'px');
        //$('.zoomContainerH').css('margin-bottom', this.module002Model.attributes.Data.ModuleMargin_Bottom + 'px');
        //$('.zoomContainerH').css('margin-left', this.module002Model.attributes.Data.ModuleMargin_Left + 'px');
        //$('.zoomContainerH').css('margin-right', this.module002Model.attributes.Data.ModuleMargin_Right + 'px');
    },
    setupBackground() {
        this.ui.templateBg.css('background-color', this.module002Model.attributes.Data.ModuleBackgroundColor);
    },
}, Backbone.Radio.Requests);